import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from "axios";
import { useUser } from '../../utils/userContext';
import useHandleErrors from '../../utils/user.utils';
import { toast } from 'react-toastify';

// WeekPicker Component

export const WeekPicker = ({ startDate, setStartDate, endDate, setEndDate, projects, setProjects, setIsSubmit }) => {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const { user } = useUser();
  const token = localStorage.getItem("token");
  const handleErrors = useHandleErrors();
  const hasFetchedRef = useRef(false);

  const handlePrevWeek = () => {
    const newStartDate = moment(startDate).subtract(1, 'week').startOf('week').toDate();
    const newEndDate = moment(startDate).subtract(1, 'week').endOf('week').toDate();
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    fetchProjects(moment(newStartDate).format('YYYY-MM-DD'), moment(newEndDate).format('YYYY-MM-DD'));
  };

  const handleNextWeek = () => {
    const newStartDate = moment(startDate).add(1, 'week').startOf('week').toDate();
    const newEndDate = moment(startDate).add(1, 'week').endOf('week').toDate();
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    fetchProjects(moment(newStartDate).format('YYYY-MM-DD'), moment(newEndDate).format('YYYY-MM-DD'));
  };

  const handleCalendarClick = (e) => {
    e.preventDefault(); // Prevents the input field from getting focus
    setCalendarOpen(!calendarOpen);
  };

  useEffect(() => {
    const currentDate = new Date();
    const start = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay()));
    const end = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));

    setStartDate(start.toISOString().split('T')[0]);
    setEndDate(end.toISOString().split('T')[0]);

    if (!hasFetchedRef.current) {
      fetchProjects(moment(start.toISOString()).format("YYYY-MM-DD"), moment(end.toISOString()).format("YYYY-MM-DD"));
      hasFetchedRef.current = true;
    }
  }, []);

  const fetchProjects = async (start, end) => {
    try {
      const params = {
        employeeId: user?.EmployeeId,
        startDate: start,
        endDate: end
      };

      const queryString = new URLSearchParams(params).toString();
      const path = `projectAllocationDates?${queryString}`;
      const URL = `${process.env.REACT_APP_BE_URL}/${path}`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        console.log("response", response.data.isSubmit);
        const projectsWithWeekDays = response.data.listProjects.map(project => ({
          ...project,
          weekDays: Array(7).fill({ hours: "" }) // Initialize weekDays array with 7 days
        }));
        setProjects(projectsWithWeekDays);
        setIsSubmit(response.data.isSubmit);
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          // Handle 404 status code separately
          setProjects([]);
          setIsSubmit(false);
        } else {
          handleErrors(error.response);
        }
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  return (
    <div>
      <div className="row justify-content-center align-items-center" id="week-picker-wrapper">
        <div className="col-auto">
          <button type="button" title="Previous Week" rel="tooltip" className="btn btn-light btn-circle ml-2 week-prev" onClick={handlePrevWeek}>
            <i className="ri-arrow-left-circle-fill"></i>
          </button>
        </div>
        <div className="col-6 text-center position-relative"> {/* Added position-relative */}
          <div className="container-fluid row-rounded px-2 mb-0">
            <div className="input-group mb-0">
              <input
                type="text"
                id="week-picker-input"
                title="Click to Pick Week"
                className="form-control week-picker text-primary"
                placeholder="Select a Week"
                value={`${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`}
                readOnly
                onClick={handleCalendarClick}
              />
              <div className="input-group-append" onClick={handleCalendarClick}>
                <div className="input-group-text"><i className="ri-calendar-2-line"></i></div>
              </div>
            </div>
            {calendarOpen && (
              <div className="calendar-container position-absolute w-100"> {/* Added position-absolute and w-100 */}
                <DatePicker
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(moment(date).startOf('week').toDate());
                    setEndDate(moment(date).endOf('week').toDate());
                    fetchProjects(moment(date).startOf('week').format('YYYY-MM-DD'), moment(date).endOf('week').format('YYYY-MM-DD'));
                  }}
                  inline
                  showWeekNumbers
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-auto">
          <button type="button" title="Next Week" rel="tooltip" className="btn btn-light btn-circle ml-2 week-next" onClick={handleNextWeek}>
            <i className="ri-arrow-right-circle-fill"></i>
          </button>
        </div>
      </div>
    </div>

  );
};

